/* src/app/shared-components/add-edit-organization-modal/add-edit-organization-modal.component.scss */
.form-group {
  margin-bottom: 1.875rem;
}
.form-group:last-child {
  margin-bottom: 0;
}
/*# sourceMappingURL=add-edit-organization-modal.component.css.map */
